/**
 * @file Validates required string fields in upload session/file metadata.
 */

/**
 * Reads a required non-empty string from upload meta.
 * @param meta - Session or file metadata object.
 * @param key - Meta key to read.
 * @param label - Human-readable label for error message (defaults to `key`).
 * @throws When value is missing, empty, or not a string.
 */
export const requireMetaString = (
  meta: Record<string, unknown>,
  key: string,
  label = key
): string => {
  const value = meta[key];
  if (typeof value !== 'string' || !value) {
    throw new Error(`Missing ${label} in upload metadata.`);
  }
  return value;
};
